import Reports from './Reports';

export default {
  priority: 100,
  name: app.translate('routes.home.attendance.reports.Reports'),
  path: 'reports',
  permissions: ['TimeAttendanceMenu/ReportsMenu'] , // ['ReportsMenu'],
  // component: Reports,
  component: load(() => import(/* webpackChunkName: "Reports" */ './Reports')),
  icon: 'file-chart',
  drawer: true,
};


